import * as React from 'react';
import * as Styled from './Button.styled';

export const ButtonColors = {
  default: 'default',
  defaultNormal: 'defaultNormal',
  dark: 'dark',
  primary: 'primary',
  secondary: 'secondary',
  purple: 'purple',
} as const;

export const ButtonSizes = {
  extraSmall: 'extraSmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: keyof typeof ButtonColors;
  size?: keyof typeof ButtonSizes;
  fluid?: boolean;
  isIcon?: boolean;
  isNoBoxShadow?: boolean;
  className?: string;
}

const Button: ReactFCWithChildren<ButtonProps> = ({
  children,
  onClick,
  color = ButtonColors.primary,
  size = ButtonSizes.medium,
  ...props
}) => {
  const commonProps = { onClick, color, size, ...props };

  return (
    <React.Fragment>
      <Styled.Button {...commonProps}>{children}</Styled.Button>
    </React.Fragment>
  );
};

export default Button;
